(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mz-halloween-v40"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-halloween-root]');
  if (!root) return;
  document.body.classList.add('mz-v4-halloween');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const batMarkup = '<svg viewBox="0 0 64 32" aria-hidden="true"><path d="M2 10c9 1 16 5 23 13l7-10 7 10c7-8 14-12 23-13-4 6-5 12-3 18-8-3-14-1-20 4-3-3-5-4-7-4s-4 1-7 4c-6-5-12-7-20-4 2-6 1-12-3-18Z"/></svg>';

  const countdown = root.querySelector('[data-h40-countdown-wrap]');
  if (countdown) {
    const welcome = document.querySelector('.v3-welcome');
    if (welcome) welcome.insertAdjacentElement('afterend', countdown);
    const target = new Date('2026-11-01T03:59:59Z').getTime();
    const updateClock = () => {
      const remaining = Math.max(0, target - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const d = countdown.querySelector('[data-h40-days]');
      const h = countdown.querySelector('[data-h40-hours]');
      const m = countdown.querySelector('[data-h40-minutes]');
      if (d) d.textContent = String(days).padStart(2, '0');
      if (h) h.textContent = String(hours).padStart(2, '0');
      if (m) m.textContent = String(minutes).padStart(2, '0');
    };
    updateClock();
    window.setInterval(updateClock, 60000);
  }

  const secretBank = root.querySelector('.mz-h40__secret-bank');
  if (secretBank) {
    secretBank.hidden = false;
    const secrets = Array.from(secretBank.querySelectorAll('[data-h40-secret]'));
    const sections = Array.from(document.querySelectorAll('#MainContent section')).filter(section => !section.classList.contains('mz-h40__countdown'));
    const hostIndexes = [1, Math.max(2, Math.floor(sections.length / 2)), Math.max(3, sections.length - 2)];
    secrets.forEach((secret, index) => {
      const host = sections[hostIndexes[index]] || sections[index] || document.querySelector('.v3-welcome');
      if (!host) return;
      host.classList.add('mz-h40-host');
      host.appendChild(secret);
    });
    let found = 0;
    secrets.forEach(secret => {
      secret.addEventListener('click', () => {
        if (secret.classList.contains('is-found')) return;
        secret.classList.add('is-found');
        found += 1;
        if (found === secrets.length) {
          const foundBox = root.querySelector('[data-h40-found]');
          if (foundBox) foundBox.hidden = false;
        }
      });
    });
  }

  document.querySelectorAll('.product-grid > *, .collection-grid > *, [data-product-card]').forEach(card => card.classList.add('mz-h40-card'));

  const spawnPop = element => {
    if (reduced || !element) return;
    const rect = element.getBoundingClientRect();
    const bat = document.createElement('span');
    bat.className = 'mz-h40-pop';
    bat.innerHTML = batMarkup;
    bat.style.left = (rect.left + rect.width / 2) + 'px';
    bat.style.top = (rect.top + Math.min(rect.height / 2, 28)) + 'px';
    document.body.appendChild(bat);
    window.setTimeout(() => bat.remove(), 800);
  };

  document.addEventListener('mouseover', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('.btn, .v3-header__brand, .v3-welcome__art--main');
    if (!target || (event.relatedTarget instanceof Node && target.contains(event.relatedTarget))) return;
    spawnPop(target);
  });

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const add = event.target.closest('[data-v3-add-button], form[action*="/cart/add"] button[type="submit"]');
    if (!add || reduced) return;
    const start = add.getBoundingClientRect();
    const cart = document.querySelector('a[href*="/cart"]');
    const end = cart ? cart.getBoundingClientRect() : {left: window.innerWidth - 44, top: 28, width: 0, height: 0};
    for (let i = 0; i < 3; i += 1) {
      const bat = document.createElement('span');
      bat.className = 'mz-h40-cart-bat';
      bat.innerHTML = batMarkup;
      bat.style.setProperty('--sx', (start.left + start.width / 2 + i * 7) + 'px');
      bat.style.setProperty('--sy', (start.top + start.height / 2 - i * 4) + 'px');
      bat.style.setProperty('--ex', (end.left + end.width / 2) + 'px');
      bat.style.setProperty('--ey', (end.top + end.height / 2) + 'px');
      bat.style.animationDelay = (i * 90) + 'ms';
      document.body.appendChild(bat);
      window.setTimeout(() => bat.remove(), 1400);
    }
  });

  const now = new Date();
  if (now.getFullYear() === 2026 && now.getMonth() === 9 && now.getDate() === 31) {
    document.body.classList.add('mz-h40-day');
  }

  if (!reduced) {
    try {
      const ghostKey = 'mz_h40_ghost_seen';
      if (!sessionStorage.getItem(ghostKey) && Math.random() < 0.06) {
        sessionStorage.setItem(ghostKey, '1');
        const ghost = root.querySelector('[data-h40-ghost]');
        if (ghost) {
          ghost.hidden = false;
          window.setTimeout(() => ghost.classList.add('is-showing'), 3800);
          window.setTimeout(() => { ghost.classList.remove('is-showing'); ghost.hidden = true; }, 11200);
        }
      }
    } catch (error) {}
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-product-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function (event) {
    if (event.target.matches('[data-v3-product-search] input[name="q"]')) event.target.setCustomValidity('');
  });
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('[data-v3-product-search]')) return;
    const input = form.querySelector('input[name="q"]');
    input.value = input.value.trim();
    if (input.value) return;
    event.preventDefault();
    input.setCustomValidity(form.dataset.searchEmpty);
    input.reportValidity();
    input.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mz-v3-system"] && !Shopify.designMode) return;
  try {
    (() => {
  let allowedOnPage = false;
  const key = 'mz_age_confirmed_v1';
  const sync = (moveFocus = false) => {
    const gate = document.getElementById('MzAgeGate');
    const content = document.getElementById('MzAgeContent');
    if (!gate || !content) return;
    let allowed = allowedOnPage;
    try { allowed = allowed || sessionStorage.getItem(key) === 'true'; } catch (error) {}
    gate.hidden = allowed;
    content.hidden = !allowed;
    if (allowed && moveFocus) document.getElementById('MainContent')?.focus();
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-mz-age-confirm]')) return;
    allowedOnPage = true;
    try { sessionStorage.setItem(key, 'true'); } catch (error) {}
    sync(true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync(), {once: true});
  else sync();
  window.addEventListener('pageshow', () => sync());
  document.addEventListener('shopify:section:load', () => sync());
})();
  } catch(e) { console.error(e); }
})();

})();
